import { render, staticRenderFns } from "./CustomerInfo.vue?vue&type=template&id=a970264e&scoped=true"
import script from "./CustomerInfo.vue?vue&type=script&lang=js"
export * from "./CustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfo.vue?vue&type=style&index=0&id=a970264e&prod&scoped=true&lang=css"
import style1 from "./CustomerInfo.vue?vue&type=style&index=1&id=a970264e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a970264e",
  null
  
)

export default component.exports